import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { storeWithExpiration } from '../../utils/common';
import { SUPER_ADMIN, PROVIDER_ADMIN, PROVIDER_TECHNICAL } from '../../config/app_config';
import {
  getAllUseCases,
  getSubscribedPlatformUseCases,
  subscribePlatformUseCase,
  unSubscribePlatformUseCase,
} from '../../actions/platformUseCase';

import ProductsIndex from '../products/ProductsIndex';

export class AccountPlatformsContainer extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    accountPlatformUseCaseList: PropTypes.object.isRequired,
    getAccountPlatformUseCaseAction: PropTypes.func.isRequired,
    getAllUseCasesAction: PropTypes.func.isRequired,
    isProviderAdmin: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    isTechnicalProvider: PropTypes.bool.isRequired,
    subscribePlatformUseCaseAction: PropTypes.func.isRequired,
    unSubscribePlatformUseCaseAction: PropTypes.func.isRequired,
    useCases: PropTypes.object.isRequired,
  };

  componentWillMount = () => {
    const { account, getAccountPlatformUseCaseAction, getAllUseCasesAction } = this.props;
    const token = storeWithExpiration.get('token');
    getAccountPlatformUseCaseAction(account.id, token);
    getAllUseCasesAction(token);
  };

  componentWillReceiveProps = nextProps => {
    const { getAccountPlatformUseCaseAction, getAllUseCasesAction } = nextProps;
    const { account } = this.props;
    if (account.id !== nextProps.account.id) {
      const token = storeWithExpiration.get('token');
      getAccountPlatformUseCaseAction(nextProps.account.id, token);
      getAllUseCasesAction(token);
    }
  };

  performPlatformUseCaseSubscription = (platformCode, useCaseCode) => {
    const { subscribePlatformUseCaseAction, account } = this.props;
    const token = storeWithExpiration.get('token');
    const platformUseCaseRequest = {
      platformCode,
      useCaseCode,
    };

    subscribePlatformUseCaseAction(account.id, token, platformUseCaseRequest);
  };

  performPlatformUseCaseUnSubscription = (platformCode, useCaseCode) => {
    const { unSubscribePlatformUseCaseAction, account } = this.props;
    const token = storeWithExpiration.get('token');
    const platformUseCaseRequest = {
      platformCode,
      useCaseCode,
    };

    unSubscribePlatformUseCaseAction(account.id, token, platformUseCaseRequest);
  };

  render() {
    const {
      accountPlatformUseCaseList,
      isProviderAdmin,
      isSuperAdmin,
      isTechnicalProvider,
      useCases,
    } = this.props;
    return (
      <div className="row">
        <div className="col-md-12">
          <ProductsIndex
            header="Platform Setup"
            accountPlatformUseCaseList={accountPlatformUseCaseList}
            isProviderAdmin={isProviderAdmin}
            isSuperAdmin={isSuperAdmin}
            isTechnicalProvider={isTechnicalProvider}
            subscribePlatformUseCaseFunction={this.performPlatformUseCaseSubscription}
            unSubscribePlatformUseCaseFunction={this.performPlatformUseCaseUnSubscription}
            useCases={useCases}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { platformUseCaseMap, user } = state;
  const accountPlatformUseCaseList = platformUseCaseMap.get('accountPlatformUseCaseList');
  const useCases = platformUseCaseMap.get('useCases');
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  const isProviderAdmin = user.get('userTypeId') === PROVIDER_ADMIN;
  const isTechnicalProvider = user.get('userTypeId') === PROVIDER_TECHNICAL;
  return {
    accountPlatformUseCaseList,
    isProviderAdmin,
    isSuperAdmin,
    isTechnicalProvider,
    useCases,
  };
};

export default connect(
  mapStateToProps,
  {
    getAccountPlatformUseCaseAction: getSubscribedPlatformUseCases,
    getAllUseCasesAction: getAllUseCases,
    subscribePlatformUseCaseAction: subscribePlatformUseCase,
    unSubscribePlatformUseCaseAction: unSubscribePlatformUseCase,
  }
)(AccountPlatformsContainer);
